import FontFaceObserver from 'fontfaceobserver';

export default class FontsLoader {
  constructor(config) {
    this.config = config;
  }

  load() {
    const fontsPromises = this.config
      .map(({ family, weight = null, style = null }) => new FontFaceObserver(family, { weight, style }).load());

    return Promise.all(fontsPromises)
      .then(() => {
        document.documentElement.classList.add('fonts-loaded');
        sessionStorage.setItem('fontsLoaded', 'true');
      })
      .catch(() => {
        sessionStorage.setItem('fontsLoaded', 'false');
      });
  }
}
